import clsx from "classnames";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { SummaryCurtain, SummaryTable, SummaryTableWrapper } from "./TransactionSummaryTable.styled";

function TransactionSummaryTable({
  children,
  collapsable,
  setCollapsed,
  collapsed
}: PropsWithChildren<{
  collapsable?: boolean;
  setCollapsed: Function;
  collapsed?: boolean;
}>) {
  const { t } = useTranslation(["transaction"]);

  return (
    <SummaryTableWrapper className={clsx(collapsed && "is-expanded", collapsable && "is-collapsable")}>
      <SummaryTable className="c-table">{children}</SummaryTable>
      {collapsable && (
        <SummaryCurtain>
          <span onClick={() => setCollapsed((current: boolean) => !current)}>
            {collapsed ? t("summary.hide-button") : t("summary.expand-button")}
          </span>
        </SummaryCurtain>
      )}
    </SummaryTableWrapper>
  );
}

export default TransactionSummaryTable;
